<template>
  <!--表单-->
    <div :class="['contact_copy_form',value?'is-visible':'']">
         <div class="formSub">
			<div class="topBar">
				<h2>我要咨询</h2>
				<a href="javascript:void(0);" class="close" @click="CloseMaterialConsult()">关闭</a>
			</div>
			<div class="forminputWrap">
				<div class="row clearfix">
					<div class="name"><b>*</b>姓名</div>
					<div class="input">
						<input type="text" placeholder="请输入" v-model="user_name">
					</div>
				</div>
				<div class="row clearfix">
					<div class="name"><b>*</b>电话</div>
					<div class="input">
						<input type="text" placeholder="请输入" v-model="user_tel">
					</div>
				</div>
				<div class="row clearfix">
					<div class="name"><b>*</b>邮箱</div>
					<div class="input">
						<input type="text" placeholder="请输入" v-model="user_email">
					</div>
				</div>
				<div class="row clearfix">
					<div class="name"><b>*</b>公司</div>
					<div class="input">
						<input type="text" placeholder="请输入" v-model="company_name">
					</div>
				</div>
				<div class="row clearfix">
					<div class="name">职位</div>
					<div class="input">
						<input type="text" placeholder="请输入" v-model="zhiwei">
					</div>
				</div>
				<div class="row clearfix">
					<div class="name"><b>*</b>备注</div>
					<div class="input">
						<textarea v-model="content" placeholder="请输入"></textarea>
					</div>
				</div>
				<div class="row clearfix">
					<label>
						<img src="../../assets/images/icon_selected_1.png" @click="setIsChecked(1)" v-if="is_checked==0">
						<img src="../../assets/images/icon_selected_2.png" @click="setIsChecked(0)" v-if="is_checked==1">
						<!-- <input v-model="is_checked" type="radio" class="a-radio">
					    <span class="b-radio"></span> -->
						<span class="tip">勾选则代表同意此填写信息共享给第三方公司以便联系为您解答</span>
					</label>
				</div>
				<div class="row">
					<a href="javascript:void(0);" @click="Submit()" class="subBtn">确认</a>
				</div>
			</div>
		 </div>

    </div>
    <!---->
</template>

<script>
import {MessageBox} from 'element-ui'
import {mapState} from "vuex";
export default {
    data(){return{
       article_id:0,
	   user_name:'',
	   user_tel:'',
	   company_name:'',
	   content:'',
	   user_email:'',
	   zhiwei:'',
       is_checked:0,
    }},
	props:['value','id'],
	computed:{
	    ...mapState('User',{
	        user_info:state=>state.user_info
	    })
	},
	components:{
		[MessageBox.name]:MessageBox
	},
	methods:{
		CloseMaterialConsult(){
			this.$emit('input',false);
		},
		Submit(){
		    if (this.is_checked==0){
		        MessageBox("请勾选同意");
		        return;
		    }
			if(this.user_name==''){
			  MessageBox("姓名未填写");
			  return;
			}
			 if(this.user_tel==''){
			  MessageBox("电话未填写");
			  return;
			}
			 if(this.user_email==''){
			  MessageBox("邮箱未填写");
			  return;
			}
			 if(this.company_name==''){
			  MessageBox("公司名称未填写");
			  return;
			}
			
			var url="http://api.xincailiao.com/Open/ContactMaterial";
			this.$http.post(url,{article_id:this.id,user_name:this.user_name,user_tel:this.user_tel,user_email:this.user_email,company_name:this.company_name,zhiwei:this.zhiwei,content:this.content}).then((res)=>{
			    if (res.data.status==1){
			        MessageBox(res.data.msg).then(()=>{
						this.$emit('input',false);
					});
			    }else{
			      MessageBox(res.data.msg);
			    }
			})
		},
		setIsChecked(_params){
			this.is_checked =_params;
		}
	}
}
</script>